<template>
  <Card title="Edit Query" no-body>
    <template #header-suffix>
      <IconTooltip
        tooltip="You can add a LIMIT to your query and toggle run off to avoid sluggishness when loading a large set of rows"
        tooltip-position="left"
      />
    </template>
    <prism-editor
      v-model="query"
      :language="language"
      :read-only="loading"
      line-numbers
      emit-events
      class="editor"
      @keyup="handleKeyUp"
    />

    <template v-slot:footer>
      <Button
        :loading="loading"
        :enabled="enabled"
        @click="read"
        variant="success"
      >
        Run
      </Button>
    </template>
  </Card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

import Button from '@/components/Button.vue';
import Card from '@/components/Card.vue';
import IconTooltip from '@/components/IconTooltip.vue';
import store from '@/plugins/vuex';

export default defineComponent({
  name: 'QueryEditor',
  components: {
    Button,
    Card,
    IconTooltip,
  },
  props: {
    enabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showSelectQuery: false,
      fields: ['query', 'run', 'delete'],
    };
  },
  computed: {
    ...mapState({
      loading: (state: any) => state.read.loading,
      type: (state: any) => state.source.type,
    }),
    language() {
      if (this.type === 'mongodb') {
        return 'json';
      }
      return 'sql';
    },
    query: {
      get(): string {
        return store.getters.read.currentQuery;
      },
      set(query: string) {
        store.dispatch.read.setCurrentQuery(query);
      },
    },
  },
  methods: {
    read() {
      store.dispatch.read.read(null);
    },
    handleKeyUp(event) {
      if (event.shiftKey && event.keyCode === 13) {
        if (event.stopPropagation) {
          event.stopPropagation();
        }
        if (event.preventDefault) {
          event.preventDefault();
        }
        // console.log('cancel bubble is?', event.cancelBubble);
        // if (has(event, 'cancelBubble')) {
        event.cancelBubble = true;
        // console.log('cancel bubble changed', event.cancelBubble);
        // }
        event.returnValue = false;
        this.read();
      }
    },
  },
});
</script>
<style scoped>
.editor {
  /* flex: 0 0 auto; */
  height: auto;
  flex: 1 1 auto;
}
</style>
